import { render, staticRenderFns } from "./JobStudentIcon.vue?vue&type=template&id=361831e8&"
import script from "./JobStudentIcon.vue?vue&type=script&lang=js&"
export * from "./JobStudentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports